import PropTypes from 'prop-types';

YesNoButtonInputWrapper.propTypes = {
  children: PropTypes.node,
};

export default function YesNoButtonInputWrapper({ children }) {
  return <div className="flex flex-col md:flex-row">{children}</div>;
}
